const NXWrench = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clipPath="url(#clip0_4287_3412)">
        <path
          d="M13.4096 3.59643C13.3903 3.49164 13.3492 3.39208 13.2889 3.30421C13.2286 3.21635 13.1505 3.14215 13.0596 3.08643L11.0596 5.08643C10.9663 5.18321 10.8545 5.2602 10.7308 5.31278C10.6071 5.36536 10.474 5.39246 10.3396 5.39246C10.2052 5.39246 10.0722 5.36536 9.94846 5.31278C9.82475 5.2602 9.71291 5.18321 9.61963 5.08643L8.85963 4.40643C8.6764 4.2195 8.57377 3.96818 8.57377 3.70643C8.57377 3.44468 8.6764 3.19336 8.85963 3.00643L10.8596 1.00643C10.816 0.903968 10.7504 0.812342 10.6675 0.738036C10.5845 0.663731 10.4863 0.608561 10.3796 0.576431C9.6818 0.437271 8.95892 0.496839 8.29329 0.748354C7.62766 0.999869 7.04602 1.43322 6.61459 1.99908C6.18316 2.56494 5.91928 3.24057 5.85299 3.94904C5.79089 4.6127 5.90452 5.2802 6.18133 5.88484L0.814623 11.2515C0.418454 11.6477 0.425024 12.292 0.82919 12.68L1.38997 13.2184C1.78111 13.5939 2.40026 13.5893 2.78575 13.2079L8.21408 7.83839C8.8012 8.08086 9.44074 8.17309 10.0745 8.10515C10.7752 8.03003 11.4414 7.76202 11.9989 7.33092C12.5565 6.89981 12.9835 6.32252 13.2325 5.66322C13.4816 5.00393 13.5429 4.28848 13.4096 3.59643Z"

          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4287_3412">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NXWrench;
